'use client';
import Image from 'next/image';

const speakers = [
  {
    name: "Yassin Soulimane",
    designation: "CMO",
    company: "Galaxy Fight Club",
    imageSrc: "/images/speakers-images/yassin-soulimane.webp",
    alt: "felix-howes",
  },
  {
    name: "Mohammad Zia",
    designation: "CEO & Managing Director",
    company: "The Akkaas",
    imageSrc: "/images/speakers-images/mohammad-zia.webp",
    alt: "mohammad-zia",
  },
  {
    name:'Tasneem Taherali',
    designation: "Advisor for Tech Startups and Scale ups - Women in Tech UAE ",
    company: "Women in Tech UAE | Global Tech Marketer ",
    imageSrc: "/images/speakers-images/tasneem.webp",
    alt: "tasneem-taherali",
  },
  {
    name: "Leila Salieva",
    designation: "Co-founder & CEO",
    company: "Sombrero Galaxy Agency",
    imageSrc: "/images/speakers-images/leila-moderator.webp",
    alt: "leila-moderator",
  },
  {
    name: "Illia",
    designation: "Founder",
    company: "SINTPashkov",
    imageSrc: "/images/speakers-images/illia.webp",
    alt: "illia",
  },

  // end of 2025 speakers
  {
    name: "Felix Howes",
    designation: "VP Business & Revenue",
    company: "Hype",
    imageSrc: "/images/speakers-images/felix-howes.webp",
    alt: "felix-howes",
  },
  {
    name: "Rachel Cheung",
    designation: "",
    company: "Foresight Ventures",
    imageSrc: "/images/speakers-images/rachel.webp",
    alt: "Rachel",
  },
  {
    name: "Zack",
    designation: "Genzio",
    company: "CEO",
    imageSrc: "/images/speakers-images/zack.webp",
    alt: "zack",
  },
  {
    name: "Trevor Koverko",
    designation: "Co-Founder",
    company: "SapienAI",
    imageSrc: "/images/speakers-images/trevor.webp",
    alt: "trevor-koverko",
  },
];

const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakerSection.jsx:74:4" data-component-path="src/app/SpeakerSection.jsx" data-component-line="74" data-component-end-line="114" data-component-file="SpeakerSection.jsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20max-w-%5B1100px%5D%20mx-auto%20px-4%20py-%5B10px%5D%20flex%20flex-col%20items-center%20justify-center%20bg-white%22%7D" id='speakers'
      className="w-full max-w-[1100px] mx-auto px-4 py-[10px] flex flex-col items-center justify-center bg-white"
    >
      <div data-component-id="src/app/SpeakerSection.jsx:77:6" data-component-path="src/app/SpeakerSection.jsx" data-component-line="77" data-component-end-line="113" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1270px%5D%22%7D" className="w-full max-w-[1270px]">
        {/* Section Title */}
        <h2 data-component-id="src/app/SpeakerSection.jsx:79:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="79" data-component-end-line="81" data-component-file="SpeakerSection.jsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B20px%5D%20sm%3Atext-%5B30px%5D%20lg%3Atext-%5B36px%5D%20font-%5B'Michroma'%5D%20font-normal%20leading-%5B30px%5D%20sm%3Aleading-%5B45px%5D%20lg%3Aleading-%5B44px%5D%20text-center%20text-%5B%23000000%5D%20w-full%20pb-10%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="text-[20px] sm:text-[30px] lg:text-[36px] font-['Michroma'] font-normal leading-[30px] sm:leading-[45px] lg:leading-[44px] text-center text-[#000000] w-full pb-10">
                  Past Speakers
        </h2>
        {/* Speaker List Box */}
        <div data-component-id="src/app/SpeakerSection.jsx:83:8" data-component-path="src/app/SpeakerSection.jsx" data-component-line="83" data-component-end-line="112" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20bg-white%20p-6%20sm%3Ap-4%22%7D" className="w-full bg-white p-6 sm:p-4">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div data-component-id="src/app/SpeakerSection.jsx:85:10" data-component-path="src/app/SpeakerSection.jsx" data-component-line="85" data-component-end-line="111" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-5%20sm%3Agap-8%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-8 place-items-center">
            {speakers.map((speaker, index) => (
              <div data-component-id="src/app/SpeakerSection.jsx:87:14" data-component-path="src/app/SpeakerSection.jsx" data-component-line="87" data-component-end-line="109" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                <div data-component-id="src/app/SpeakerSection.jsx:89:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="89" data-component-end-line="99" data-component-file="SpeakerSection.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B120px%5D%20h-%5B120px%5D%20sm%3Aw-%5B200px%5D%20sm%3Ah-%5B200px%5D%20relative%20mb-4%22%7D" className="w-[120px] h-[120px] sm:w-[200px] sm:h-[200px] relative mb-4">
                  <Image data-component-id="src/app/SpeakerSection.jsx:90:18" data-component-path="src/app/SpeakerSection.jsx" data-component-line="90" data-component-end-line="98" data-component-file="SpeakerSection.jsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-full%22%7D"
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    width={300}
                    height={300}
                    objectFit="cover"
                    className="rounded-full"
                    unoptimized
                  />
                </div>
                <h3 data-component-id="src/app/SpeakerSection.jsx:100:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="100" data-component-end-line="102" data-component-file="SpeakerSection.jsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%236f4afc%5D%20text-%5B14px%5D%20sm%3Atext-%5B16px%5D%20font-semibold%20text-center%20mb-1%22%7D" className="text-[#6f4afc] text-[14px] sm:text-[16px] font-semibold text-center mb-1">
                  {speaker.name}
                </h3>
                <p data-component-id="src/app/SpeakerSection.jsx:103:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="103" data-component-end-line="105" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-black%20text-%5B12px%5D%20sm%3Atext-%5B12px%5D%20text-center%20mb-1%22%7D" className="text-black text-[12px] sm:text-[12px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p data-component-id="src/app/SpeakerSection.jsx:106:16" data-component-path="src/app/SpeakerSection.jsx" data-component-line="106" data-component-end-line="108" data-component-file="SpeakerSection.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-black%20text-%5B12px%5D%20sm%3Atext-%5B10px%5D%20text-center%22%7D" className="text-black text-[12px] sm:text-[10px] text-center">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpeakerSection;
